import React, { useEffect, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import Team from "./team/";
import WorkOrder from "./work-order/";
import Parts from "./parts/";
import Cost from "./cost/";
import { LocationFilter } from "../../components/LocationFilter";

function Analytics() {
  const [location, setLocation] = useState(null)
  const handleChangeLocationFilter = (location) => {
    setLocation(location?.id)
  };

  return (  
    <div>
      <div class="d-flex justify-content-between">
        <h1 className="page-header">
          Analytics <small>stats, overview & performance</small>
        </h1>
        <div>
          <LocationFilter onChange={handleChangeLocationFilter} />
        </div>
      </div>


      <ul className="nav nav-tabs">
        <li className="nav-item me-1">
          <a href="#team" className="nav-link active" data-bs-toggle="tab">
            <i className="fa fa-users-gear"></i> Work Order
          </a>
        </li>
        {/* <li className="nav-item me-1">
          <a href="#work-order" className="nav-link" data-bs-toggle="tab">
            <i className="fa fa-user-gear"></i> Work Order
          </a>
        </li> */}
        <li className="nav-item me-1">
          <a href="#parts" className="nav-link" data-bs-toggle="tab">
            <i className="fa fa-boxes-packing"></i> Parts & Inventory
          </a>
        </li>
        <li className="nav-item me-1">
          <a href="#cost" className="nav-link" data-bs-toggle="tab">
            <i className="fa fa-money-bill"></i> Cost of Maintenance
          </a>
        </li>
        {/*<li className="nav-item me-1">*/}
        {/*  <a href="#purchase" className="nav-link" data-bs-toggle="tab">*/}
        {/*    <i className="fa fa-file-invoice-dollar"></i> Purchase Order*/}
        {/*  </a>*/}
        {/*</li>*/}
      </ul>
      <div className="tab-content pt-3">
        <div className="tab-pane fade show active" id="team" >
          <Team locationId={location} />
        </div>
        <div className="tab-pane fade" id="cost" >
          <Cost locationId={location} />
        </div>
        <div className="tab-pane fade" id="work-order" >
          <WorkOrder locationId={location} />
        </div>
        <div className="tab-pane fade" id="purchase" >
          d...
        </div>
        <div className="tab-pane fade" id="parts" >
          <Parts locationId={location} />
        </div>
      </div>
    </div>
  );
}

export default Analytics;
